import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'keepDecimal'})
export class KeepDecimalPipe implements PipeTransform {
    public transform(input:string, digitCount: number): string{
        if (!input) {
            return '';
        } else {
            return Number.parseFloat(input).toFixed(digitCount);
        }
    }
    
}